import React from 'react';
import './Timeline.css';

type TimelineStep = {
    id: string;
    label: string;
    status: 'completed' | 'current' | 'upcoming';
    icon: string;
};

interface TimelineProps {
    currentStatus: string;
}

const Timeline: React.FC<TimelineProps> = ({ currentStatus }) => {
    // 상태 순서 정의
    const steps: TimelineStep[] = [
        { id: 'new', label: '신규', status: 'upcoming', icon: '✨' },
        { id: 'interview', label: '인터뷰', status: 'upcoming', icon: '🎤' },
        { id: 'ebook_creating', label: '전자책 생성중', status: 'upcoming', icon: '✏️' },
        { id: 'ebook_complete', label: '전자책 생성 완료', status: 'upcoming', icon: '📚' },
        { id: 'physical_edit', label: '실물책 편집', status: 'upcoming', icon: '📖' },
        { id: 'printing', label: '인쇄', status: 'upcoming', icon: '🖨️' },
        { id: 'delivery', label: '배송', status: 'upcoming', icon: '🚚' },
        { id: 'delivery_complete', label: '배송완료', status: 'upcoming', icon: '📦' }
    ];

    // 현재 상태에 따라 스텝 상태 업데이트
    const getStepStatus = (stepId: string): 'completed' | 'current' | 'upcoming' => {
        const statusMap: { [key: string]: number } = {
            '신규': 0,
            '인터뷰': 1,
            '전자책 생성중': 2,
            '전자책 생성 완료': 3,
            '실물책 편집': 4,
            '인쇄': 5,
            '배송': 6,
            '배송완료': 7
        };

        const currentStepIndex = statusMap[currentStatus] || 0;
        const stepIndex = steps.findIndex(step => step.id === stepId);

        if (stepIndex < currentStepIndex) {
            return 'completed';
        } else if (stepIndex === currentStepIndex) {
            return 'current';
        } else {
            return 'upcoming';
        }
    };

    const updatedSteps = steps.map(step => ({
        ...step,
        status: getStepStatus(step.id)
    }));

    console.log(updatedSteps);
    
    return (
        <div className="timeline-container">
            <div className="timeline">
                {updatedSteps.map((step, index) => (
                    <div key={step.id} className={`timeline-step ${step.status}`}>
                        <div className="timeline-step-content">
                            <div className="timeline-icon">
                                {step.icon}
                            </div>
                            <div className="timeline-label">
                                {step.label}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Timeline;